<form [formGroup]="form">
    <div class="container p-2">
      <h2 *ngIf="mode != modes.NEW && mode != modes.EDIT" class="mb-2">{{ 'addOrEditVehicleGroup' | translate }}</h2>
      <h2 *ngIf="mode == modes.EDIT" class="mb-2">{{ 'selectedVehicleGroup' | translate }}</h2>
      <h2 *ngIf="mode == modes.NEW" class="mb-2">{{ 'addingNewVehicleGroup' | translate }}</h2>
      <div fxLayout="column">
        <ng-container>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <mat-form-field *ngIf="mode != modes.NEW && mode != modes.EDIT">
              <mat-label>{{ 'searchVehicleGroup' | translate }}</mat-label>
              <input type="text" #searchInput matInput formControlName="name" [matAutocomplete]="auto">
              <button *ngIf="searchInput.value.length > 0" matSuffix mat-icon-button (click)="$event.stopPropagation(); deselect()">
                <mat-icon svgIcon="close"></mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="vehicleGroupEdit($event)">
                <mat-option *ngFor="let group of filteredVehicleGroups$ | async" [value]="group">
                  {{ group.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="mode == modes.NEW || mode == modes.EDIT">
            <app-form-editor #vehicleGroupForm [formFieldElements]="formFields" addModeText=""
              editModeText="" [showCancel]="false" [hideTopAddButton]="true" [translateOptions]="false"
              (saveObject)="saveVehicleGroup($event)">
            </app-form-editor>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between" class="mt-5">
            <button mat-raised-button type="button" color="simsRed" [disabled]="mode != modes.EDIT"
              (click)="this.removeVehicleGroup(vehicleGroup)">
              {{ 'removeGroup' | translate }}
            </button>
            <button mat-raised-button type="button" color="sims" [disabled]="" (click)="handleAddNew()">
              {{ 'addVehicleGroup' | translate }}
            </button>
            <button mat-raised-button *ngIf="mode != modes.NONE" color="sims" type="button" (click)="handleCancelClick()">
              {{ 'cancel' | translate }}
            </button>
            <button mat-raised-button *ngIf="mode == modes.NONE" color="sims" type="button" (click)="cancelAndRevert()">
              {{ 'back' | translate }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </form>